export const getMostActiveFeature = featureUsageReport => {
  const features = Object.entries(featureUsageReport)
  if (features?.length > 0) {
    const mostActive = features.reduce((acc, cv) =>
      cv[1] >= acc[1] ? cv : acc
    )
    return mostActive[0]
  }
}

export const getFeatureDisplayName = machine_name => {
  switch (machine_name) {
    case "documents":
    case "polls":
    case "surveys":
    case "questionnaires":
    case "lists":
    case "leaderboard":
    case "livestream":
    case "camera":
    case "places":
      return (
        machine_name.substring(0, 1).toUpperCase() + machine_name.substring(1)
      )

    case "comment_board":
    case "private_message":
    case "countdown_clock":
    case "form_builders":
    case "video_call":
    case "event_info":
    case "basic_content":
    case "view_bookings":
      return machine_name
        .replace(/_/g, " ")
        .replace(
          /\w\S*/g,
          txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        )

    case "trivia_challenge":
      return "Trivias"

    case "custom_web_links":
      return "Web Link"

    case "guest_list":
      return "Attendee List"

    case "media":
      return "Media Gallery"

    case "calendar":
      return "View Calendar Events"

    case "register_guest":
      return "Register Visitors"

    case "refer_friend":
      return "Refer a Friend"

    case "booking_service":
      return "Create a Booking"

    default:
      return machine_name
  }
}

export const getTop5ActiveFeature = featureUsageReport => {
  const features = Object.entries(featureUsageReport)
  if (features?.length > 0) {
    const sortedFeatures = [...features].sort((a, b) => {
      if (a[1] < b[1]) return 1
      if (a[1] > b[1]) return -1
      return 0
    })
    return sortedFeatures
      .filter(item => item[1] > 0)
      .slice(0, 5)
      .map(item => ({ name: getFeatureDisplayName(item[0]), views: item[1] }))
  } else {
    return []
  }
}

export const FeatureNameTicks = ({ x, y, stroke, payload, fontSize }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={0}
        textAnchor="end"
        fill="#666"
        fontSize={fontSize ? `${fontSize}px` : ""}
      >
        <tspan>{payload.value}</tspan>
      </text>
    </g>
  )
}

const moment = require("moment")
export const generateChartDataLastXDays = (days, data) => {
  const startDate = moment().subtract(days, "days").format("MM-DD-YYYY")
  const endDate = moment()

  const countOfDays = endDate.diff(startDate, "days")

  let preparedData = []

  for (let i = 0; i <= countOfDays; i++) {
    const current = moment(startDate).add(i, "day").format("MM-DD-YYYY")
    const date = data.find(x => x?.date === current)
    preparedData.push({ date: current, value: date?.value || 0 })
  }

  return preparedData
}
